import { FieldsStatIcon } from "./SummaryStatIcons";
import { SummaryStatVariant } from "../SummaryStatCard";

export const totalFields: SummaryStatVariant = {
  icon: <FieldsStatIcon />,
  label: "Total Fields",
};
